export enum EDocumentsSearchModeType
{
    daysSinceCreate = "Days Since Create",
    fileName = "File Name",
    createDate = "Create Date",
    folderName = "Folder",
    drawerName = "Drawer",
    cabinetName = "Cabinet",
}

export enum AddressDisplayMode
{
    Address1Only,
    Address1And2Seperate,
    Address1And2Combined,
}